import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MembersEffects } from './effects/members.effects';
import { MemberDetailsComponent } from './member-details/member-details.component';
import { MembersComponent } from './members.component';
import { MEMBERS_ROUTES } from './members.routes';
import { ModalAddMemberComponent } from './modals/modal-add-member/modal-add-member.component';
import { ModalAttachGroupComponent } from './modals/modal-attach-group/modal-attach-group.component';
import { ModalAttachRoleComponent } from './modals/modal-attach-role/modal-attach-role.component';
import { ModalDeleteMemberComponent } from './modals/modal-delete-member/modal-delete-member.component';
import { ModalDetachGroupComponent } from './modals/modal-detach-group/modal-detach-group.component';
import { ModalDetachRoleComponent } from './modals/modal-detach-role/modal-detach-role.component';
import { ModalImportMembersComponent } from './modals/modal-import-members/modal-import-members.component';
import * as fromMembers from './reducers/members.reducer';
import { SmashChartModule } from '@app/shared/modules/smash-chart/smash-chart.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SmashDataTableModule } from '@app/shared/modules/smash-data-table/smash-data-table.module';
import { SmashCsvExportComponent } from '@app/shared/components/smash-csv-export/smash-csv-export.component';


@NgModule({
  declarations: [
    MembersComponent,
    MemberDetailsComponent,
    ModalAddMemberComponent,
    ModalDeleteMemberComponent,
    ModalAttachGroupComponent,
    ModalDetachGroupComponent,
    ModalImportMembersComponent,
    ModalAttachRoleComponent,
    ModalDetachRoleComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashChartModule,
    SmashFormsModule,
    SmashDataTableModule,
    SmashCsvExportComponent,
    RouterModule.forChild(MEMBERS_ROUTES),
    EffectsModule.forFeature([MembersEffects]),
    StoreModule.forFeature(fromMembers.membersFeatureKey, fromMembers.reducer),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MembersModule { }
